import React, { useState } from 'react';
import './imagePreview.css'
import '@splidejs/react-splide/css'; // Default CSS
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { act } from '@testing-library/react';

function C2wImagePreview({ activeIndex = null, imagesData = null, setImgPreFlag=null }) {

  const [activeImgIndex, setActiveImgIndex] = useState(activeIndex)

  const handleIndex = (splide, newIndex, oldIndex) => {
    console.log(`Moved from slide ${oldIndex} to ${newIndex}`);
    yourFunction(newIndex);
  };

  const yourFunction = (index) => {
    setActiveImgIndex(index)
  };

  return (
    <section className='crasouel_scrollers' aria-label="Beautiful Images">
      <button className='backBtn' onClick={() => {
        setImgPreFlag(false)
}}> <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6325 1.71581L16.9167 0L9.31625 7.6125L1.71581 0L0 1.71581L7.6125 9.31625L0 16.9167L1.71581 18.6325L9.31625 11.02L16.9167 18.6325L18.6325 16.9167L11.02 9.31625L18.6325 1.71581Z" fill="white" />
        </svg></button>
      <Splide
        options={{
          type: 'slide',
          perPage: 1,
          autoplay: false,
          interval: 3000,
          pauseOnHover: false,
          arrows: true,
          pagination: false,
          drag: false,         // ⛔ Disables mouse/touch sliding
          keyboard: false,     // ⛔ Disables arrow key navigation
          swipe: false,        // ⛔ Ensures swipe on mobile is off
        }}
        onMove={(splide, newIndex, oldIndex) => handleIndex(splide, newIndex, oldIndex)}

        aria-label="My Beautiful Carousel"
      >{imagesData && imagesData?.map((image, index) => (
        <SplideSlide>
          <img className='Carousel_image' src={imagesData[activeImgIndex]?.src} alt="Slide 1" />
        </SplideSlide>
      ))}
      </Splide>
    </section>
  )
}

export default C2wImagePreview
